export default "__VITE_ASSET__BKRUIzGc__"